import { useState, useRef, useEffect } from 'react'
import { Button, Expandable, TinyMCE } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useRecoilState } from 'recoil'
import { editCaseFieldSelector } from 'atoms'
import { CaseInputWrapper } from 'components/dashboard/CaseDetails/CaseInputWrappers'
import { useTranslation } from 'react-i18next'
import { TINYMCE_CASE_FIELD_SCHEMA } from 'components/global/TinyMCE/tinyMCESchema'

export const Obituary = ({
  saveCase,
  caseDetails,
  setActiveTab,
  activeTab,
}) => {
  const { t } = useTranslation()
  const [obit, setObit] = useRecoilState(
    editCaseFieldSelector({ name: 'obituary', path: 'value' }),
  )
  const editorRef = useRef(null)
  const [expandedObit, setExpandedObit] = useState(true)

  useEffect(() => {
    setExpandedObit(true)
  }, [activeTab])

  const save = () => {
    if (editorRef.current) {
      const content = editorRef.current.getContent()
      setObit(content)
      saveCase()
      setActiveTab(t('caseDetails.tabs.serviceInfo.title'))
    }
  }

  const handleBlur = () => {
    if (editorRef.current) {
      let content = editorRef.current.getContent()
      if (!content) content = '<p></p>'
      setObit(content)
    }
  }

  return (
    <Flex column full padding="0 40px 0 0">
      <Flex column align="flex-start">
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.obituary.title')}
          show={[expandedObit, setExpandedObit]}
          full
        >
          <CaseInputWrapper
            width="100%"
            margin="0 24px 24px 0"
            label={t('caseDetails.tabs.obituary.websiteObituaryUrl')}
            name="website_obit_url"
          />
          <Text size="12px" margin="0 0 8px">
            {t('caseDetails.tabs.obituary.title')}
          </Text>
          <Flex
            border="1px solid"
            borderColor="gray4"
            height="500px"
            margin="0 0 25px 0"
            overflow="auto"
            padding="2px"
            onBlur={handleBlur}
            background="lockedWhite"
            id="obituary"
          >
            <TinyMCE
              setRef={(ref) => (editorRef.current = ref)}
              value={obit}
              caseDetails={caseDetails}
              plainTextMode={true}
              init={{
                toolbar: false,
                ...TINYMCE_CASE_FIELD_SCHEMA,
              }}
            />
          </Flex>

          <Flex justify="flex-end">
            <Button primary onClick={() => save()}>
              {t('caseDetails.saveAndContinueButton')}
            </Button>
          </Flex>
        </Expandable>
      </Flex>
    </Flex>
  )
}

export default Obituary
